import { useEffect } from 'react';
import { getSearchedStudents } from 'layouts/students/service/studentsApi';

export const useStudentSearchEffect = (
  query,
  setLoading,
  setOptions,
  handleErrorResponse
) => {
  useEffect(() => {
    const fetchStudents = async () => {
      if (!query || query.length < 1) return;

      try {
        setLoading(true);
        const result = await getSearchedStudents(query, false, false, 20);
        setOptions(result?.items || []);
      } catch (error) {
        handleErrorResponse(error?.response?.data?.message);
      } finally {
        setLoading(false);
      }
    };

    fetchStudents();
  }, [query]);
};

// Handle removing student from Include IDs
export const handleIdsChange = (value, setIds, setValue, fieldName) => {
  const updatedIds = value
    ? value
    : typeof value === 'string'
    ? value.split(',').filter((id) => id.trim())
    : [];

  setIds(updatedIds);
  setValue(fieldName, updatedIds);
};

export const handleAddIdOnEnter = ({
  event,
  selected,
  ids,
  setIds,
  setValue,
  field,
  notify,
  emptyMsg,
  duplicateMsg,
}) => {
  if (event.key !== 'Enter') return;

  if (!selected) {
    notify(emptyMsg);
    return;
  }

  if (ids.includes(selected.studentId)) {
    notify(duplicateMsg);
    return;
  }

  const updatedIds = [...ids, selected.studentId];
  setIds(updatedIds);
  setValue(field, updatedIds);
  return true;
};

export const mapToIdValue = (arr) =>
  arr?.map((item) => ({ id: item, value: item })) || [];
